import React from 'react';
import {
  expandableListBuilder,
} from '@its/components/lib/Container components/ExpandableListContainer/ExpandableListContainer';

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);
    const mapStateToProps = (state) => ({
      lists: state.app.templates.maps.lists,
      route: 'template/map/add',
    });

    const ExpandableListContainer = expandableListBuilder(mapStateToProps);
    this.component = <ExpandableListContainer />;
  }

  render() {
    return this.component;
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Template/Map/MapList.js
 **/